'use client'

import { useState } from 'react'
import { ChevronDown, Eye } from 'lucide-react'

interface PolicyItem {
  hsId: string
  policyId: string
  hsCode: string
  policy: {
    id: string
    name: string
    slug: string
    appliedDate: string
    status: string
  }
}

interface PolicyTableProps {
  policyList: PolicyItem[]
}

export default function PolicyTable({ policyList }: PolicyTableProps) {
  const [showAll, setShowAll] = useState(false)
  const INITIAL_SHOW_COUNT = 5

  const displayedList = showAll
    ? policyList
    : policyList.slice(0, INITIAL_SHOW_COUNT)

  const hasMore = policyList.length > INITIAL_SHOW_COUNT

  return (
    <>
      <table className="policy-table">
        <thead>
          <tr>
            <th>Chính sách</th>
            <th style={{ width: '150px' }}>Ngày áp dụng</th>
            <th style={{ width: '120px' }}>Tình trạng</th>
          </tr>
        </thead>
        <tbody>
          {displayedList.map((item: PolicyItem) => {
            if (!item.policy) return null

            const status = getPolicyStatus(item.policy.status)

            return (
              <tr key={item.policyId}>
                <td>
                  <a
                    target="_blank"
                    href={createPolicyLink(item.policy)}
                    className="policy-name"
                  >
                    {item.policy.name}
                  </a>
                </td>
                <td className="policy-date">{item.policy.appliedDate}</td>
                <td>
                  <span className={`status-badge ${status.className}`}>
                    {status.label}
                  </span>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>

      {hasMore && !showAll && (
        <div className="flex justify-center mt-6">
          <button
            onClick={() => setShowAll(true)}
            className="inline-flex items-center gap-2 px-6 py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Xem thêm
            <ChevronDown className="w-4 h-4" />
          </button>
        </div>
      )}
    </>
  )
}

function getPolicyStatus(status: string): {
  className: string
  label: string
} {
  // Map status from database to display
  switch (status?.toLowerCase()) {
    case 'đang có hiệu lực':
    case 'đang áp dụng':
      return {
        className: 'status-active',
        label: 'Còn hiệu lực',
      }
    default:
      return {
        className: 'status-unknown',
        label: 'Không xác định',
      }
  }
}

function createPolicyLink(policy: PolicyItem['policy']): string {
  return `https://caselaw.vn/chi-tiet-chinh-sach/${policy.slug}`
}
